import { queryOfURL } from './url';

// 缓存urlprojectCode相关信息，方便开发
export const URL_LOCATION_KEY = 'URL_LOCATION_KEY';

export const getUrlLocation = () => {
  const { latitude = '', longitude = '' } = queryOfURL(location.search);
  if (latitude && longitude) {
    localStorage.setItem(
      URL_LOCATION_KEY,
      JSON.stringify({
        latitude,
        longitude,
      }),
    );
  }
};
